import CryptoJS from "crypto-js";
import { BANK_NAME } from "../constants/enum";
import { maskPhoneNumber } from "./numberFormat";

export function objectToQueryString(obj: Record<string, unknown>): string {
  return Object.keys(obj).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(String(obj[key]))}`).join('&');
}

export const hashedInput = (input: string): string => {
  try {
    const hashed = CryptoJS.SHA256(input).toString();
    return hashed;
  } catch (error) {
    console.log(error);
    return "";
  }
};

export const otpLabel = (bankName: string, phoneNumber: string = ""): string => {
  if (bankName === BANK_NAME.AXIS) {
    return `Sent to ${maskPhoneNumber(phoneNumber)} by Axis bank`;
  } else {
    return `Enter Otp`;
  }
};

export const sendMessageToApp = (
  message: Record<string, unknown> | string,
  userDetails: { bank?: string } = {}
): unknown => {
  try {
    const bankName =
      typeof message === "object" && message !== null
        ? message.bankName
        : undefined;
    const bankMatch = !userDetails.bank || bankName === userDetails.bank;

    if (window.ReactNativeWebView && bankMatch) {
      window.ReactNativeWebView.postMessage(
        typeof message === "object" ? JSON.stringify(message) : message
      );
    } else {
      console.log("Message sent (fallback):", message);
    }
  } catch (error) {
    console.error("Error sending message to app:", error);
    return error;
  }
};
